import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import entrepriseBlogFormationProfessionnelleFonctionnementStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'entrepriseBlogFormationProfessionnelleFonctionnement'
const customImplement: CustomStoreImplementationOptions = entrepriseBlogFormationProfessionnelleFonctionnementStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function entrepriseBlogFormationProfessionnelleFonctionnementFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('article-fonctionnement-de-la-formation-p.title', ' Fonctionnement de la formation professionnelle'),
        $description: $translate('article-fonctionnement-de-la-formation-p.description', 'Découvrez comment la formation professionnelle avantage les petites entreprises en comprenant son fonctionnement. Depuis la réforme de la formation professionnelle de 2018 l\'accès à la formation s\'est grandement simplifié et adaptée aux besoins des PME ! '),
        $publishedTime: new Date('2023-05-25T13:34:01.555Z'),
        $modifiedTime: new Date('2023-08-23T11:44:49.300Z'),
        // Constants,
        $constants: {
          ilSagitDunOutil: 'Il s’agit d’un "outil" au service de tous : salariés, indépendants, chefs d’entreprise ou demandeurs d’emploi...etc qui permet de <strong>se former tout au long de sa vie professionnelle</strong>, pour :<br> <p><ul><li>accéder à un emploi ;</li><li>s’y maintenir (entretenir son employabilité) ;</li><li>en changer (reconversion / spécialisation) ;</li><li>développer ses compétences.</li></ul><p> <br>Depuis la dernière <strong>réforme de la formation professionnelle en 2018</strong>, la définition d’une action de formation a totalement changé. </p>',
          uneActionDeFormation: 'Une action de formation se définit depuis le 1 er janvier 2019 comme<strong> "Un parcours pédagogique permettant d’atteindre un objectif professionnel." </strong>',
          question1Hidden: false,
          question1Hidden1: null,
          texteDeveloppeHidden: false,
          texteDeveloppeHidden1: null
        },
        // Data,
        $info: { articleFonctionnementDeLaFormationP: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      derouleClick () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      derouleClickWhenSelected () {
        this.$elements['question-1'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container31Click () {
      },
      /* @ts-ignore: to allow override in your custom file */
      container31ClickWhenSelected () {
      },
      /* @ts-ignore: to allow override in your custom file */
      container34Click () {
        this.$elements['container-36'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container34ClickWhenSelected () {
        this.$elements['container-36'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container44Click () {
        this.$elements['texte-developpe'].style = { hidden: this.$constants.texteDeveloppeHidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container44ClickWhenSelected () {
        this.$elements['texte-developpe'].style = { hidden: this.$constants.texteDeveloppeHidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container50Click () {
        this.$elements['container-52'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container50ClickWhenSelected () {
        this.$elements['container-52'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container54Click () {
        this.$elements['container-56'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container54ClickWhenSelected () {
        this.$elements['container-56'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      container58Click () {
        this.$elements['container-60'].style = { hidden: this.$constants.question1Hidden }
      },
      /* @ts-ignore: to allow override in your custom file */
      container58ClickWhenSelected () {
        this.$elements['container-60'].style = { hidden: this.$constants.question1Hidden1 }
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRdvPourEnClick () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      rechercherUnExpertClick () {
        openUrl('/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      reseauClick () {
        openUrl('https://www.linkedin.com/company/linkedin-com-company-matchers/', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return entrepriseBlogFormationProfessionnelleFonctionnementFactory(storeId)()
}

export const entrepriseBlogFormationProfessionnelleFonctionnementRaw = entrepriseBlogFormationProfessionnelleFonctionnementFactory()
export const entrepriseBlogFormationProfessionnelleFonctionnement = () => entrepriseBlogFormationProfessionnelleFonctionnementRaw() as MergeCustomStore<typeof entrepriseBlogFormationProfessionnelleFonctionnementStoreCustom.instance>
